import styled from 'styled-components';

export const ContainerAddFilters = styled.div`
  margin-top: 12px;
`;

export const FilterMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 20px;
  gap: 10px;
  background-color: ${({ theme }) => theme.palette.common.white};
  min-width: 300px;
  max-height: 450px;
  display: flex;

  color: ${({ theme }) => theme.palette.text.primary};
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border-radius: 4px;
  box-shadow: ${({ theme }) => theme.palette.grey[400]} 0px 2px 1px -1px,
    ${({ theme }) => theme.palette.grey[300]} 0px 1px 1px 0px, ${({ theme }) => theme.palette.divider} 0px 1px 3px 0px;
`;

export const NoFilters = styled.p`
  font-size: 14px;
  margin-top: 0;
`;
